import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	error: {
		height: '100px',
		display: 'flex',
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		borderWidth: token('border.width'),
		borderStyle: 'dashed',
		borderColor: token('color.border'),
	},
});

export const AttachmentErrorState = (): React.JSX.Element => (
	<Box xcss={styles.error} testId="field-input-attachment-view-error">
		<StatusWarningIcon spacing="spacious" color={token('color.icon.warning')} label="" />
		<FormattedMessage {...messages.defaultRenderError} />
	</Box>
);
